// extracted by mini-css-extract-plugin
export default {"background":"styles_background__AMwc0","loginForm":"styles_loginForm__5j1zl","logo":"styles_logo__Nl4LB","spinnerContainer":"styles_spinnerContainer__-R3Uf"};